const closeButton = document.querySelector("#close-modal");
const holder = document.querySelector("#popUpHolder");
const url = window.location.href;

const checkForRedirect = () => {
  if (
    url.split("?").includes("panoskin-redirect") ||
    url.split("?").includes("panoskin-redirect=")
  ) {
    holder.style.display = "flex";
    document.body.classList.add("modal-open");
  }
};

checkForRedirect();

const closePopUp = () => {
  holder.style.display = "none";
  document.body.classList.remove("modal-open");
};

closeButton.addEventListener("click", closePopUp);
